import utils, { getHasElementsInArray } from 'utils';

export const SORT_VALUES = {
  LEAD: 'name',
  NUMBER_OF_ENQUIRIES: 'numberOfPreviousEnquiries',
  LAST_ENQUIRE: 'lastEnquire',
};

export const getQueryArrayParam = (options: string[]) =>
  getHasElementsInArray(options) ? utils.mapArrayToParams(options) : undefined;
